import React from 'react'

import Hero from '../../views/Landing/Hero'
import Prospects from '../../views/Landing/Prospects'
import FindLove from '../../views/Landing/FindLove'
import Helped from '../../views/Landing/Helped'

import './styles/main.css'
import Say from '../../views/Landing/Say'
import Search from '../../views/Landing/Search'

function Main() {

    return (

        <main className={`--main`}>

            <div className='--content-main'>
            
                <Hero/>

                <Prospects/>

                <FindLove/>

                <Helped/>

                <Say/>

                <Search/>
            
            </div>

        </main>

    )

}

export default Main